import React, { useState } from "react";
import "./Profile.css";

export default function Profile({ userName, setUserName }) {
  const [currentUserName, setCurrentUserName] = useState("");
  return (
    <div className="profile">
      <div className="main-content">
        <h1>Profile</h1>
        <label>User Name</label>
        <input
          type="text"
          placeholder={userName}
          value={currentUserName}
          onChange={(e) => setCurrentUserName(e.target.value)}
        ></input>
        <div className="bottom">
          <button
            disabled={currentUserName.length === 0}
            onClick={() => {
              setUserName(currentUserName);
              localStorage.setItem("userName", currentUserName);
              setCurrentUserName("");
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
